export const getTransactionId = (eventName: 'join' | 'adultcert' | 'purchase') => {
  return `${eventName}_${Date.now()}_${Math.floor(Math.random() * 99999999999)}`;
};
